module.exports = __webpack_public_path__ + "img/no-searchresults.1dc93c70.svg";